import { render, staticRenderFns } from "./WitnessesEdit.vue?vue&type=template&id=0cda3520&"
import script from "./WitnessesEdit.vue?vue&type=script&lang=js&"
export * from "./WitnessesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports